import { c as _c } from "react/compiler-runtime";
import { useAuth0 } from "@auth0/auth0-react";
import { getAccessToken } from "../../../../hooks/useApi";
import { useContext, useEffect, useState } from "react";
import { AlertCircle, Check } from "react-feather";
import { toast } from "react-toastify";
import { Donor } from "../../../../models";
import style from "./ProfileInfo.module.scss";
import { DonorContext } from "../../layout/donorProvider";
import { saveDonor } from "../../_queries";
import { EffektButton } from "../../../shared/components/EffektButton/EffektButton";
import { EffektCheckbox } from "../../../shared/components/EffektCheckbox/EffektCheckbox";
import { ErrorMessage } from "../../shared/ErrorMessage/ErrorMessage";
export type ProfilePageInfoConfiguration = {
  name_label: string;
  email_label: string;
  newsletter_label: string;
  save_button_label: string;
  success_message: string;
  failure_message: string;
};
export const ProfileInfo: React.FC<{
  config: ProfilePageInfoConfiguration;
  titleTemplate: string;
}> = t0 => {
  const $ = _c(49);
  const {
    config,
    titleTemplate
  } = t0;
  const {
    getAccessTokenSilently,
    user
  } = useAuth0();
  const {
    donor: initialDonor,
    setDonor: setGlobalDonor
  } = useContext(DonorContext);
  const [donor, setDonor] = useState(initialDonor);
  let t1;
  let t2;
  if ($[0] !== donor || $[1] !== initialDonor) {
    t1 = () => {
      if (!donor && initialDonor) {
        setDonor(initialDonor);
      }
    };
    t2 = [donor, initialDonor];
    $[0] = donor;
    $[1] = initialDonor;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (!donor || !user) {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <ErrorMessage />;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t3;
  if ($[5] !== config.failure_message || $[6] !== config.success_message || $[7] !== donor || $[8] !== getAccessTokenSilently || $[9] !== setGlobalDonor || $[10] !== user) {
    t3 = async () => {
      const token = await getAccessToken(getAccessTokenSilently);
      const result = await saveDonor(donor, user, token);
      if (result === null) {
        failureToast(config.failure_message);
      } else {
        successToast(config.success_message);
        setGlobalDonor(donor);
      }
    };
    $[5] = config.failure_message;
    $[6] = config.success_message;
    $[7] = donor;
    $[8] = getAccessTokenSilently;
    $[9] = setGlobalDonor;
    $[10] = user;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const save = t3;
  let t4;
  if ($[12] !== donor.name || $[13] !== titleTemplate) {
    let t5;
    if ($[15] !== donor.name) {
      t5 = donor.name ? " " + donor.name.split(" ")[0] : "";
      $[15] = donor.name;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    t4 = titleTemplate.replace("{{name}}", t5);
    $[12] = donor.name;
    $[13] = titleTemplate;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[17] !== t4) {
    t5 = <h3 className={style.header}>{t4}</h3>;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== donor) {
    t6 = e => {
      setDonor({
        ...donor,
        name: e.target.value
      });
    };
    $[19] = donor;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== donor.name || $[22] !== t6) {
    t7 = <input id="name" type="text" defaultValue={donor.name} className={style.input} onChange={t6} />;
    $[21] = donor.name;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== config.name_label || $[25] !== t7) {
    t8 = <div className={style.inputContainer}>{config.name_label}{t7}</div>;
    $[24] = config.name_label;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== donor.email) {
    t9 = <input id="email" type="email" disabled={true} value={donor.email} className={style.input} />;
    $[27] = donor.email;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== config.email_label || $[30] !== t9) {
    t10 = <div className={style.inputContainer}>{config.email_label}{t9}</div>;
    $[29] = config.email_label;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== donor) {
    t11 = () => {
      setDonor({
        ...donor,
        newsletter: !donor.newsletter
      });
    };
    $[32] = donor;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== config.newsletter_label || $[35] !== donor.newsletter || $[36] !== t11) {
    t12 = <div className={style.inputContainer}><EffektCheckbox checked={donor.newsletter} onChange={t11}>{config.newsletter_label}</EffektCheckbox></div>;
    $[34] = config.newsletter_label;
    $[35] = donor.newsletter;
    $[36] = t11;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== config.save_button_label || $[39] !== save) {
    t13 = <EffektButton role="submit" onClick={save} cy="btn-save">{config.save_button_label}</EffektButton>;
    $[38] = config.save_button_label;
    $[39] = save;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== t10 || $[42] !== t12 || $[43] !== t13 || $[44] !== t8) {
    t14 = <section className={style.personalInfo}>{t8}{t10}{t12}{t13}</section>;
    $[41] = t10;
    $[42] = t12;
    $[43] = t13;
    $[44] = t8;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  let t15;
  if ($[46] !== t14 || $[47] !== t5) {
    t15 = <>{t5}{t14}</>;
    $[46] = t14;
    $[47] = t5;
    $[48] = t15;
  } else {
    t15 = $[48];
  }
  return t15;
};
const successToast = (msg: string) => toast.success(msg, {
  icon: <Check size={24} color={"black"} />
});
const failureToast = (msg: string) => toast.error(msg, {
  icon: <AlertCircle size={24} color={"black"} />
});